import { useLoadClient } from './useLoadClient';
import { useSendCustomerAttributes } from './useSendCustomerAttributes';

export const useShowButton = () => {
  const { clientLoaded } = useLoadClient();
  const { attributesSent } = useSendCustomerAttributes({ clientLoaded });

  return { showButton: clientLoaded && attributesSent };
};
